import React from 'react';
import ManagePartyBankForm from '../Forms/manage_party_bank_form';
import { ManageDataPage } from './manageDataShared';

const COLUMNS = [
    { label: 'Name', field: 'Name' },
    { label: 'Address', field: 'Address' },
    { label: 'Bin No.', field: 'Bin' },
];

function Manage_party_bank() {
    return (
        <ManageDataPage
            title="Manage Party Bank"
            endpoint="get_manage_party_bank_table"
            columns={COLUMNS}
            idKey="PartyBankID"
            FormComponent={ManagePartyBankForm}
            searchPlaceholder="Search bank, address, BIN..."
        />
    );
}

export default Manage_party_bank;
